// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"About_pageContainer__3laiv","listContainer":"About_listContainer___wqNg","headingBox":"About_headingBox__3mF-E","tableContainer":"About_tableContainer__UGJA7"};